import { createSelector } from 'reselect'

const getState = state => state.OrganisationFiles

const getFetchOrganisationFilesRequest = state =>
  getState(state).fetchOrganisationFilesRequest

const getOrganisationFiles = state => getState(state).organisationFiles

const getOrganisationFilesResult = createSelector(
  [getOrganisationFiles],
  organisationFiles => (!organisationFiles ? [] : organisationFiles.result)
)

const getOrganisationFilesMap = createSelector(
  [getOrganisationFiles],
  organisationFiles =>
    !organisationFiles ? {} : organisationFiles.entities.organisationFiles
)

const getOrganisationFilesList = createSelector(
  [getOrganisationFilesResult, getOrganisationFilesMap],
  (result, organisationFilesMap) => result.map(id => organisationFilesMap[id])
)

const getOrganisationFile = (state, id) => getOrganisationFilesMap(state)[id]

const getBenchmarkFilter = state => getState(state).filters.benchmarked

export {
  getOrganisationFiles,
  getOrganisationFilesList,
  getFetchOrganisationFilesRequest,
  getOrganisationFile,
  getBenchmarkFilter
}
